module.exports = __webpack_public_path__ + "static/img/lisboa2.e0b3951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/lisboa2.jpg
// module id = vaTR
// module chunks = 1